export enum DeviceType {
  ENVIROQ = 'ENVIROQ',
  THERMALQ = 'THERMALQ',
  AIRWITS_PM = 'AIRWITS_PM',
  AIRWITS_CO2 = 'AIRWITS_CO2',
  AIRWITS_CO2_PLUS = 'AIRWITS_CO2_PLUS',
  AIRWITS = 'AIRWITS',
  DETECTIFY = 'DETECTIFY',
  DRAGINO_RS485 = 'DRAGINO_RS485',
  ADEUNIS_PULSE = 'ADEUNIS_PULSE',
  ADEUNIS_PULSE_3 = 'ADEUNIS_PULSE_3',
  ADEUNIS_PULSE_WATER = 'ADEUNIS_PULSE_WATER',
  FLEXSENSE = 'FLEXSENSE',
  FLEXSENSE_PROBE = 'FLEXSENSE_PROBE',
  VOLTDROP = 'VOLTDROP',
  VOLTDROP_PHASE = 'VOLTDROP_PHASE',
  EASTRON_POWER = 'EASTRON_POWER',
  AXIOMA_WATER = 'AXIOMA_WATER',
  SOLAR_CSV = 'SOLAR_CSV',
  MILESIGHT_EM300 = 'MILESIGHT_EM300',
  MILESIGHT_EM320 = 'MILESIGHT_EM320',
  MILESIGHT_AM102 = 'MILESIGHT_AM102',
  MILESIGHT_AM103 = 'MILESIGHT_AM103',
  MILESIGHT_AM308 = 'MILESIGHT_AM308',
  MILESIGHT_AM319 = 'MILESIGHT_AM319',
  MILESIGHT_VS121 = 'MILESIGHT_VS121',
  MILESIGHT_VS351 = 'MILESIGHT_VS351',
  MILESIGHT_VS321 = 'MILESIGHT_VS321',
  MILESIGHT_VS360 = 'MILESIGHT_VS360',
  MILESIGHT_VS34X = 'MILESIGHT_VS34X',
  MILESIGHT_VS330 = 'MILESIGHT_VS330',
  MILESIGHT_WS202 = 'MILESIGHT_WS202',
  MILESIGHT_WS203 = 'MILESIGHT_WS203',
  MILESIGHT_WS523 = 'MILESIGHT_WS523',
  MILESIGHT_CT = 'MILESIGHT_CT',
  MILESIGHT_CT_THREE_PHASE = 'MILESIGHT_CT_THREE_PHASE',
  MILESIGHT_CT_PHASE = 'MILESIGHT_CT_PHASE',
  /** Milesight CTH01 Smart Power Monitor Hub; its circuits are the virtual children below */
  MILESIGHT_CTH01 = 'MILESIGHT_CTH01',
  MILESIGHT_CTH01_CIRCUIT = 'MILESIGHT_CTH01_CIRCUIT',
  MILESIGHT_CTH01_THREE_PHASE_CIRCUIT = 'MILESIGHT_CTH01_THREE_PHASE_CIRCUIT',
  MILESIGHT_CTH01_PHASE = 'MILESIGHT_CTH01_PHASE',
  MOKO_LW005 = 'MOKO_LW005',
  PCS_FLOWMETER = 'PCS_FLOWMETER',
  KROHNE_AFE400_FLOWMETER = 'KROHNE_AFE400_FLOWMETER',
  PFLOW_E3R_FLOWMETER = 'PFLOW_E3R_FLOWMETER',
  GATEWAY = 'GATEWAY',
  HOTDROP = 'HOTDROP',
  ROOM_RADAR = 'ROOM_RADAR',
  ROOM_RADAR_LINE = 'ROOM_RADAR_LINE',
  ROOM_RADAR_REGION = 'ROOM_RADAR_REGION',
  NZ_ICP = 'NZ_ICP',
  ELSYS_ERS = 'ELSYS_ERS',
  ELSYS_ERS_LITE = 'ELSYS_ERS_LITE',
  ELSYS_ERS_CO2 = 'ELSYS_ERS_CO2',
  ELSYS_ERS_CO2_LITE = 'ELSYS_ERS_CO2_LITE',
  ELSYS_ERS_VOC = 'ELSYS_ERS_VOC',
  ELSYS_ERS_EYE = 'ELSYS_ERS_EYE',
  ELSYS_ERS_SOUND = 'ELSYS_ERS_SOUND',
  EASTRON_SDM_230 = 'EASTRON_SDM_230',
  QUANDIFY_CUBICMETER = 'QUANDIFY_CUBICMETER',
  BOVE_BECO = 'BOVE_BECO',
  VICTRON_ENERGY_INVERTER = 'VICTRON_ENERGY_INVERTER',
  GENUS_INTELLILOG = 'GENUS_INTELLILOG',
}

export const MODBUS_DEVICE_TYPES = [DeviceType.DRAGINO_RS485, DeviceType.PCS_FLOWMETER, DeviceType.KROHNE_AFE400_FLOWMETER];
